import styles from './Spinner.module.css';

function Spinner() {
  return (
    <div className={styles.loader}/>
  )
}

export default Spinner;
